import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Box,
  Divider,
  Button,
  Grid,
  Checkbox,
  FormControlLabel,
  Radio,
  RadioGroup,
  Slider,
  Link,
  Rating
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// Filter Configuration Maps
const FILTER_CONFIG = {
  languages: [
    { label: 'English', value: 'en' },
    { label: 'Chinese', value: 'zh-TW' },
    { label: 'Dutch', value: 'nl' },
    { label: 'French', value: 'fr' },
    { label: 'German', value: 'de' },
    { label: 'Italian', value: 'it' },
    { label: 'Japanese', value: 'ja' },
    { label: 'Portuguese', value: 'pt' },
    // { label: 'Russian', value: 'RUSSIAN' },
    // { label: 'Spanish', value: 'SPANISH' },
  ],
  timesOfDay: [
    { label: 'Morning', sub: 'Starts before 12pm', value: 'MORNING' },
    { label: 'Afternoon', sub: 'Starts after 12pm', value: 'AFTERNOON' },
    { label: 'Evening and night', sub: 'Starts after 5pm', value: 'EVENING_AND_NIGHT' }
  ],
  durations: [
    { label: 'Up to 1 hour', value: 'ZERO_TO_ONE_HOUR' },
    { label: '1 to 4 hours', value: 'ONE_TO_FOUR_HOURS' },
    { label: '4 hours to 1 day', value: 'FOUR_HOURS_TO_ONE_DAY' },
    { label: '1 to 3 days', value: 'ONE_TO_THREE_DAYS' },
    { label: '3+ days', value: 'THREE_DAYS_PLUS' }
  ],
  ratings: [
    { value: 5, enum: 'FIVE_STAR' },
    { value: 4, enum: 'FOUR_STAR' },
    { value: 3, enum: 'THREE_STAR' }
  ],
  specials: [
    { label: 'Deals & Discounts', value: 'DEALS_AND_DISCOUNTS' },
    { label: 'Free Cancellation', value: 'FREE_CANCELLATION' },
    { label: 'Likely to Sell Out', value: 'LIKELY_TO_SELL_OUT' },
    { label: 'Skip-The-Line', value: 'SKIP_THE_LINE' },
    { label: 'Private Tour', value: 'PRIVATE_TOUR' },
    { label: 'New on Viator', value: 'NEW_ON_VIATOR' }
  ]
};

const FilterSection = ({ title, children, action }) => (
  <Box sx={{ py: 3 }}>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
      <Typography variant="h6" sx={{ fontSize: '1.1rem', fontWeight: 500 }}>
        {title}
      </Typography>
      {action && action}
    </Box>
    {children}
  </Box>
);

export default function FilterModal({ open, onClose,onSubmit,price,flags,currency,durations }) {
  // State for all filters
  const [priceRange, setPriceRange] = useState([0, 47800]);
  const [languages, setLanguages] = useState([]);
  const [timesOfDay, setTimesOfDay] = useState([]);
  const [duration, setDuration] = useState('');
  const [rating, setRating] = useState('');
    const [specials, setSpecials] = useState([]);

    
    
    

     useEffect(() => {
    if (price) {
      setPriceRange(price);
    }

  
  }, [price]);

  // Generic array toggle handler for checkboxes
  const handleToggle = (stateUpdater, currentState, value) => {
    const currentIndex = currentState.indexOf(value);
    const newArray = [...currentState];
    if (currentIndex === -1) {
      newArray.push(value);
    } else {
      newArray.splice(currentIndex, 1);
    }
      stateUpdater(newArray);
      
     
  };

  const handleClearAll = () => {
    setPriceRange(price);
    setLanguages([]);
    setTimesOfDay([]);
    setDuration('');
    setRating('');
    setSpecials([]);
    };
    

    useEffect(() => {
        handleSubmit()
    },[specials,duration,rating,languages])

  const handleSubmit = () => {
    // Generate the desired JSON structure
    const payload = {
      sortType: "EXTERNAL",
      minPrice: priceRange[0],
      maxPrice: priceRange[1],
      dynamicFilters: [], // Set as needed or populate via state
      rating: rating || null,
      timesOfDay: timesOfDay,
      durations: duration,
      specials: specials,
      popularTags: [],
      operatorCodes: [],
      waysToExperience: [],
     
        appliedLanguages: languages
      
      };
      
      if (onSubmit) {
      onSubmit(payload);
    }

    //   onClose()
    console.log("Generated JSON Payload:", JSON.stringify(payload, null, 2));
    
    // Optional: onClose(); if you want it to close after generating results
    };
    
    const formatLabel = (value) => {
  if (!value) return '';

  return value
    .toLowerCase()
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      scroll="paper"
      PaperProps={{
        sx: { borderRadius: 3, maxHeight: '85vh' }
      }}
    >
      {/* HEADER */}
      <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          Filter
        </Typography>
        <IconButton
                  aria-label="close"
                  style={{width:'fit-content'}}
                  
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
            bgcolor: (theme) => theme.palette.grey[100],
            '&:hover': { bgcolor: (theme) => theme.palette.grey[200] }
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      
      <Divider />

      {/* SCROLLABLE BODY */}
      <DialogContent sx={{ p: 0, px: 3 }}>
        
        {/* Languages Section */}
        <FilterSection title="Languages">
          <Grid container spacing={2}>
            {FILTER_CONFIG.languages.map((lang) => (
              <Grid item xs={12} sm={6} key={lang.value}>
                <FormControlLabel 
                  control={
                    <Checkbox 
                      checked={languages.includes(lang.value)}
                      onChange={() => handleToggle(setLanguages, languages, lang.value)}
                      sx={{ '&.Mui-checked': { color: '#008768' } }} 
                    />
                  } 
                  label={lang.label} 
                />
              </Grid>
            ))}
          </Grid>
        
        </FilterSection>

        <Divider />

        {/* Time of Day Section */}
        {/* <FilterSection title="Time of Day">
          <Grid container spacing={2}>
            {FILTER_CONFIG.timesOfDay.map((time) => (
              <Grid item xs={12} sm={6} key={time.value}>
                <FormControlLabel
                  control={
                    <Checkbox 
                      checked={timesOfDay.includes(time.value)}
                      onChange={() => handleToggle(setTimesOfDay, timesOfDay, time.value)}
                      sx={{ '&.Mui-checked': { color: '#008768' } }} 
                    />
                  }
                  label={
                    <Box>
                      <Typography sx={{ fontWeight: 500 }}>{time.label}</Typography>
                      <Typography variant="body2" color="text.secondary">{time.sub}</Typography>
                    </Box>
                  }
                  sx={{ alignItems: 'flex-start', mt: 0.5 }}
                />
              </Grid>
            ))}
          </Grid>
        </FilterSection> */}

        <Divider />

        {/* Duration Section */}
       <FilterSection
  title="Duration"
  action={
    <Link
      component="button"
      variant="body2"
      underline="always"
      color="text.primary"
      onClick={() => setDuration('')}
    >
      Clear
    </Link>
  }
>
  <RadioGroup
    value={duration}
    onChange={(e) => setDuration(e.target.value)}
  >
    <Grid container spacing={2}>
      {durations.map((durationItem) => (
        <Grid item xs={12} sm={6} key={durationItem.key}>
          <FormControlLabel
            value={durationItem.key}
            control={
              <Radio
                sx={{
                  '&.Mui-checked': {
                    color: '#008768',
                  },
                }}
              />
            }
            label={durationItem.label}
          />
        </Grid>
      ))}
    </Grid>
  </RadioGroup>
</FilterSection>

        <Divider />

        {/* Price Section */}
        <FilterSection title="Price">
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                      <Typography>{currency} {priceRange[0]}</Typography>
                      <Typography>{currency} {priceRange[1] === price[1] ?  `${price[1]}+` : priceRange[1]}</Typography>
          </Box>
          <Slider
            value={priceRange}
            onChange={(e, newValue) => setPriceRange(newValue)}
                      valueLabelDisplay="off"
                    onChangeCommitted={handleSubmit}  
            min={price[0]}
            max={price[1]}
            sx={{
              color: '#000',
              height: 4,
              '& .MuiSlider-thumb': {
                height: 24,
                width: 24,
                backgroundColor: '#fff',
                border: '2px solid currentColor',
                '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
                  boxShadow: 'inherit',
                },
              },
            }}
          />
        </FilterSection>

        <Divider />

        {/* Rating Section */}
        <FilterSection 
          title="Rating" 
          action={
            <Link 
              component="button" 
              variant="body2" 
              underline="always" 
              color="text.primary"
              onClick={() => setRating('')}
            >
              Clear
            </Link>
          }
        >
          <RadioGroup value={rating} onChange={(e) => setRating(e.target.value)}>
            <Grid container spacing={2}>
              {FILTER_CONFIG.ratings.map((r) => (
                <Grid item xs={12} sm={6} key={r.enum}>
                  <FormControlLabel
                    value={r.enum}
                    control={<Radio sx={{ '&.Mui-checked': { color: '#008768' } }} />}
                    label={
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Rating value={r.value} readOnly size="small" sx={{ color: '#008768' }} />
                        <Typography variant="body2">& up</Typography>
                      </Box>
                    }
                  />
                </Grid>
              ))}
            </Grid>
          </RadioGroup>
        </FilterSection>

        <Divider />

        {/* Specials Section */}
        <FilterSection title="Specials">
          <Grid container spacing={2}>
            {flags.map((special) => (
              <Grid item xs={12} sm={6} key={special.value}>
                <FormControlLabel 
                  control={
                    <Checkbox 
                      checked={specials.includes(special.value)}
                      onChange={() => handleToggle(setSpecials, specials, special.value)}
                      sx={{ '&.Mui-checked': { color: '#008768' } }} 
                    />
                  } 
                        
                  label={formatLabel(special?.value)} 
                />
              </Grid>
            ))}
          </Grid>
        </FilterSection>

      </DialogContent>

      <Divider />

      {/* FOOTER */}
      <DialogActions sx={{ px: 3, py: 2, justifyContent: 'space-between' }}>
        <Link
          component="button"
          variant="body1"
          underline="always"
          color="text.primary"
          sx={{ fontWeight: 'bold' }}
          onClick={handleClearAll}
        >
          Clear all
        </Link>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            bgcolor: '#008768',
            color: 'white',
            fontWeight: 'bold',
            px: 3,
            py: 1,
            textTransform: 'none',
            borderRadius: 2,
            '&:hover': {
              bgcolor: '#006B52',
            }
          }}
        >
          See results
        </Button>
      </DialogActions>
    </Dialog>
  );
}